var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49843 7.49794C8.05167 6.9447 8.94865 6.9447 9.5019 7.49794L17.0002 14.9962L24.4984 7.49794C25.0517 6.9447 25.9487 6.9447 26.5019 7.49794C27.0551 8.05118 27.0551 8.94817 26.5019 9.50141L19.0036 16.9997L26.5019 24.4979C27.0551 25.0512 27.0551 25.9482 26.5019 26.5014C25.9487 27.0547 25.0517 27.0547 24.4984 26.5014L17.0002 19.0031L9.5019 26.5014C8.94865 27.0547 8.05167 27.0547 7.49843 26.5014C6.94519 25.9482 6.94519 25.0512 7.49843 24.4979L14.9967 16.9997L7.49843 9.50141C6.94519 8.94817 6.94519 8.05118 7.49843 7.49794Z",
    fill: "#092543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.105a0b53e5e6a372cae5ab47844476e9.svg";
export { ForwardRef as ReactComponent };